import React from 'react';
import Footer from '@/components/Footer';
import './index.less';
const FooterContent = (<>
    <span>@诸葛·数据智能平台</span>{' '}
    
  </>);
export default function BasicLayout(props) {
    return (<>
      <div className="page-container">{props.children}</div>
      <Footer className="footer" text={FooterContent}/>
    </>);
}
